/**
 * @author mrdoob / http://mrdoob.com/
 */
// function about the animations in the timeline
import UI from './libs/ui'
import FRAME from '../../src/Frame'
import uniqid from 'uniqid'
var Animations = function (editor) {

	var signals = editor.signals;

	var container = new UI.Panel();
	container.setHeight('2000px');
	container.setBackground('linear-gradient(#444 1px, transparent 1px) 0% 0% / 50px 50px repeat');

	var scale = 32;

	var Block = (function (animation) {

		var scope = this;

		var dom = document.createElement('div');
		dom.className = 'block';
		dom.style.position = 'absolute';
		dom.style.height = '50px';
		dom.addEventListener('click', function (event) {
			event.stopPropagation()
			editor.selectAnimation(animation);

		});
		dom.addEventListener('mousedown', function (event) {
			event.stopPropagation();

			var movementX = 0;
			var movementY = 0;

			function onMouseMove(event) {

				movementX = event.movementX | event.webkitMovementX | event.mozMovementX | 0;

				animation.start += movementX / scale;
				animation.end += movementX / scale;

				if (animation.start < 0) {

					var offset = - animation.start;

					animation.start += offset;
					animation.end += offset;
					updateTimesForSubComponents(animation, (movementX / scale) + offset)
				} else {
					updateTimesForSubComponents(animation, movementX / scale)
				}



				movementY += event.movementY | event.webkitMovementY | event.mozMovementY | 0;

				if (movementY >= 30) {

					animation.layer = animation.layer + 1;
					movementY = 0;

				}

				if (movementY <= -30) {

					animation.layer = Math.max(0, animation.layer - 1);
					movementY = 0;

				}

				signals.animationModified.dispatch(animation);

			}

			function onMouseUp(event) {

				document.removeEventListener('mousemove', onMouseMove);
				document.removeEventListener('mouseup', onMouseUp);

			}

			document.addEventListener('mousemove', onMouseMove, false);
			document.addEventListener('mouseup', onMouseUp, false);

		}, false);

		var resizeLeft = document.createElement('div');
		resizeLeft.style.position = 'absolute';
		resizeLeft.style.width = '6px';
		resizeLeft.style.height = '50px';
		resizeLeft.style.cursor = 'w-resize';
		resizeLeft.addEventListener('mousedown', function (event) {

			event.stopPropagation();

			var movementX = 0;

			function onMouseMove(event) {

				movementX = event.movementX | event.webkitMovementX | event.mozMovementX | 0;

				let timeToIncrement = movementX / scale
				if (!collisionWithSubComponentsResizeLeft(timeToIncrement)) {
					animation.start += movementX / scale;

					signals.animationModified.dispatch(animation);
				}

			}

			function collisionWithSubComponentsResizeLeft(timeToIncrement) {
				let incrementedStartTime = animation.start + timeToIncrement
				let collision = animation.elements.find(element => {
					let el = element.line || element.animation
					if (el) {
						return incrementedStartTime >= el.startTime
					}
					return false
				})

				return collision
			}

			function onMouseUp(event) {

				if (Math.abs(movementX) < 2) {

					editor.selectAnimation(animation);

				}

				document.removeEventListener('mousemove', onMouseMove);
				document.removeEventListener('mouseup', onMouseUp);

			}

			document.addEventListener('mousemove', onMouseMove, false);
			document.addEventListener('mouseup', onMouseUp, false);

		}, false);
		dom.appendChild(resizeLeft);

		var name = document.createElement('div');
		name.className = 'name';
		dom.appendChild(name);


		var subComponentContainer = document.createElement('div');
		subComponentContainer.id = 'subComponentContainer'
		dom.appendChild(subComponentContainer)

		var img = document.createElement('div');
		img.className = 'backgroundImage'
		img.style.backgroundSize = 'contain';
		img.style.backgroundRepeat = 'repeat-x';
		img.style.height = "50px";
		dom.appendChild(img);

		var resizeRight = document.createElement('div');
		resizeRight.style.position = 'absolute';
		resizeRight.style.right = '0px';
		resizeRight.style.top = '0px';
		resizeRight.style.width = '6px';
		resizeRight.style.height = '50px';
		resizeRight.style.cursor = 'e-resize';
		resizeRight.addEventListener('mousedown', function (event) {

			event.stopPropagation();

			var movementX = 0;

			function onMouseMove(event) {

				movementX = event.movementX | event.webkitMovementX | event.mozMovementX | 0;
				let timeToIncrement = movementX / scale
				if (!collisionWithSubComponentsResizeRight(timeToIncrement)) {
					animation.end += timeToIncrement;

					signals.animationModified.dispatch(animation);
				}

			}

			function collisionWithSubComponentsResizeRight(timeToIncrement) {
				let incrementedEndTime = animation.end + timeToIncrement
				let collision = animation.elements.find(element => {
					let el = element.line || element.animation
					if (el) {
						return incrementedEndTime < el.endTime
					}
					return false
				})

				return collision
			}


			function onMouseUp(event) {

				if (Math.abs(movementX) < 2) {

					editor.selectAnimation(animation);

				}

				document.removeEventListener('mousemove', onMouseMove);
				document.removeEventListener('mouseup', onMouseUp);

			}

			document.addEventListener('mousemove', onMouseMove, false);
			document.addEventListener('mouseup', onMouseUp, false);

		}, false);
		dom.appendChild(resizeRight);

		//

		function getAnimation() {

			return animation;

		}

		function select() {

			dom.classList.add('selected');

		}

		function deselect() {

			dom.classList.remove('selected');

		}

		function update() {

			animation.enabled === false ? dom.classList.add('disabled') : dom.classList.remove('disabled');

			dom.style.left = (animation.start * scale) + 'px';
			dom.style.top = (animation.layer * 50) + 'px';
			dom.style.width = ((animation.end - animation.start) * scale - 2) + 'px';

			removeAllElements(subComponentContainer)

			// only update height if element is line or animation
			let shouldUpdateDomHeight = false
			animation.elements.forEach((element) => {
				if (element.line || element.animation) {
					shouldUpdateDomHeight = true
					if (subBlocks[element.id] === undefined) {
						const subComponent = createSubComponent(element, animation, dom)
						subBlocks[element.id] = subComponent;
						subComponentContainer.appendChild(subComponent.dom)
					}
					else {
						const subComponent = subBlocks[element.id]
						subComponentContainer.appendChild(subComponent.dom)
					}
					updateSubcomponent(subBlocks[element.id], element, dom)
				}
			})
			if (shouldUpdateDomHeight) {
				updateDomHeightForElements(animation.elements, dom)
			}


			// this displays the text in the animation
			// also commented name css in dark css
			dom.style.textAlign = 'center';
			name.innerHTML = animation.name + ' <span style="opacity:0.5">' + '</span>';

		}

		update();

		// function renderSubComponents () {
		// 	let elements = animation.elements

		// 	elements.forEach((el) => {
		// 		let subComponent = createSubComponent(el, animation, dom)
		// 		subComponentContainer.appendChild(subComponent)
		// 	})

		// 	updateDomHeightForElements(elements, dom)

		// }
		// renderSubComponents()

		return {
			dom: dom,
			getAnimation: getAnimation,
			select: select,
			deselect: deselect,
			update: update
		};

	});

	function updateSubcomponent (subcomponent, el, dom) {
		const element = el.line || el.animation
		const name = element.voiceName || element.name
		subcomponent.dom.style.left = ((element.startTime * scale) - parseFloat(dom.style.left)) + 'px';
		subcomponent.dom.style.width = ((element.endTime - element.startTime) * scale - 2) + 'px';
		subcomponent.dom.innerHTML = name
		subcomponent.dom.dataset.id = el.id

	}

	function updateTimesForSubComponents (animation, moveBy) {
		animation.elements = animation.elements.map(element => {
			let el = element.line || element.animation
			if (el) {
				el.startTime += moveBy
				el.endTime += moveBy
			}
			return element
		})
	}

	function removeAllElements(container) {
		while (container.children.length) {

			container.removeChild(container.lastChild);

		}
	}


	function updateDomHeightForElements(elements, dom) {
		let numberOfSubComponentTypes = Object.keys(elements).length

		let totalHeight = 50
		if (numberOfSubComponentTypes >= 2) {
			totalHeight += 50
		} else if (numberOfSubComponentTypes === 1) {
			totalHeight += 25
		}
		dom.style.height = totalHeight + "px"
	}

	function createSubComponent(el, animation, dom) {
		var element = el.line || el.animation
		var bottom = getSubComponentBottomHeight(el, animation.elements) + "px"
		var subDom = document.createElement('div');
		var name = element.voiceName || element.name
		subDom.className = 'subBlock'
		subDom.style.height = "25px";
		subDom.style.backgroundColor = "rgb(255,255,255,0.2)";
		subDom.style.whiteSpace = "nowrap"
		subDom.style.overflow = "hidden"
		subDom.style.textOverflow = "ellipsis"
		subDom.style.border= "1px solid rgb(255,255,255,0.8)"

		subDom.style.left = ((element.startTime * scale) - parseFloat(dom.style.left)) + 'px';
		subDom.style.position = "absolute";
		subDom.style.width = ((element.endTime - element.startTime) * scale - 2) + 'px';
		subDom.style.bottom = bottom
		subDom.dataset.id = el.id
		subDom.innerHTML = name

		// subDom.appendChild(resizeSubComponent(animation, el, 'left'))
		// subDom.appendChild(resizeSubComponent(animation, el, 'right'))

		subDom.addEventListener('click', function (event) {
			event.stopPropagation();

			signals.animationSelected.dispatch(animation)
			signals.animationSubComponentSelected.dispatch(el, animation);
		})

		subDom.addEventListener('mousedown', function (event) {
			event.stopPropagation();

			var movementX = 0;

			function onMouseMove(event) {

				movementX = event.movementX | event.webkitMovementX | event.mozMovementX | 0;

				let timeToIncrement = movementX / scale

				// this traps the subcomponent within the animation
				if (!collisionWithOtherSubComponents(el, timeToIncrement) && (element.startTime + timeToIncrement) >= animation.start && (element.endTime + timeToIncrement) <= animation.end) {
					element.startTime += timeToIncrement;
					element.endTime += timeToIncrement;

					// I think this can be deleted -dj
					if (element.startTime < 0) {

						var offset = - element.startTime;

						element.startTime += offset;
						element.endTime += offset;

					}
					//

					signals.animationModified.dispatch(animation);
				}
			}

			function collisionWithOtherSubComponents(el, timeToIncrement) {
				let type = el.line ? 'line' : 'animation'
				let subComponent = el.line || el.animation
				let incrementedStartTime = subComponent.startTime + timeToIncrement
				let incrementedEndTime = subComponent.endTime + timeToIncrement
				let collision = animation.elements.filter(element => element[type]).find(element => {
					if (element === el) return

					let otherSubComponent = element.line || element.animation
					return incrementedStartTime <= otherSubComponent.endTime && incrementedEndTime >= otherSubComponent.startTime
				})

				return collision
			}

			function onMouseUp(event) {

				document.removeEventListener('mousemove', onMouseMove);
				document.removeEventListener('mouseup', onMouseUp);

			}

			document.addEventListener('mousemove', onMouseMove, false);
			document.addEventListener('mouseup', onMouseUp, false);

		}, false);

		function select() {

			subDom.classList.add('selected');

		}

		function deselect() {

			subDom.classList.remove('selected');

		}

		return {
			dom: subDom,
			select: select,
			deselect: deselect
		};

	}

	function getSubComponentBottomHeight(currentElement, elements) {
		if (currentElement.animation) {
			return 25
		}

		if (currentElement.line) {
			return 0
		}
	}

	function resizeSubComponent (animation, el, direction) {
		var subComponent = el.line || el.animation
		var resize = document.createElement('div');
		resize.style.position = 'absolute';
		resize.style.width = '20px';
		resize.style.height = '25px';
		resize.style.bottom = "0"
		resize.style.cursor = 'w-resize';
		if (direction === 'right') {
			resize.style.right = '0px';
			resize.style.cursor = 'e-resize';
		}

		resize.addEventListener('dblclick', function (event) {
			if (direction === 'right') {
				subComponent.endTime = getNearestTime(el, animation, direction)
			} else if (direction === 'left') {
				subComponent.startTime = getNearestTime(el, animation, direction)
			}

			signals.animationModified.dispatch(animation);
		})
		resize.addEventListener('mousedown', function (event) {

			event.stopPropagation();

			var movementX = 0;

			function onMouseMove(event) {

				movementX = event.movementX | event.webkitMovementX | event.mozMovementX | 0;

				let timeToIncrement = movementX / scale
				if (!collisionWithOtherSubComponents(el, timeToIncrement, direction)) {
					if (direction === 'right' && (subComponent.endTime + timeToIncrement) <= animation.end) {
						subComponent.endTime += timeToIncrement;
					} else if (direction === 'left' && (subComponent.startTime + timeToIncrement) >= animation.start) {
						subComponent.startTime += timeToIncrement;
					}
					signals.animationModified.dispatch(animation);
				}

			}

			function collisionWithOtherSubComponents(el, timeToIncrement, direction) {
				let type = el.line ? 'line' : 'animation'
				let subComponent = el.line || el.animation
				let incrementedStartTime = subComponent.startTime + timeToIncrement
				let incrementedEndTime = subComponent.endTime + timeToIncrement
				let collision = animation.elements.filter(element => element[type]).find(element => {
					if (element === el) return

					let otherSubComponent = element.line || element.animation
					if (direction === "right") {
						if (subComponent.endTime < otherSubComponent.startTime) {
							return incrementedEndTime >= otherSubComponent.startTime
						}
					} else {
						if (subComponent.startTime > otherSubComponent.endTime) {
							return incrementedStartTime <= otherSubComponent.endTime
						}
					}
				})

				return collision
			}

			function onMouseUp(event) {

				if (Math.abs(movementX) < 2) {

					editor.selectAnimation(animation);

				}

				document.removeEventListener('mousemove', onMouseMove);
				document.removeEventListener('mouseup', onMouseUp);

			}

			document.addEventListener('mousemove', onMouseMove, false);
			document.addEventListener('mouseup', onMouseUp, false);

		}, false);

		return resize;
	}

	container.dom.addEventListener('dblclick', function (event) {
		if (!editor.selected && !selectedSubBlock) {
			var start = event.offsetX / scale;
			var end = start + 20;
			var layer = Math.floor(event.offsetY / 50);

			var effect = new FRAME.Effect('Effect');
			editor.addEffect(effect);

			var animation = new FRAME.Animation(uniqid(), 'Unassigned Node', start, end, layer, effect);
			editor.addAnimation(animation);
		}
	});


	container.dom.addEventListener('click', function (event) {
		if (editor.selected) {
      var block = blocks[editor.selected.id]
      if(block !== undefined){
        block.deselect()
      }
			editor.selected = null
			signals.animationSelected.dispatch(null)
		}

		if (selectedSubBlock) {
      const block = subBlocks[selectedSubBlock]
      if (block !== undefined) {
        block.deselect()
      }
			selectedSubBlock = null
			signals.animationSelected.dispatch(null)
		}
	});

	// signals

	var blocks = {};
	var subBlocks = {};
	var selected = null;
	var selectedSubBlock = null;

	signals.animationPhaseChanged.add(function (animation) {
		let block = blocks[animation.id]
		applyColorByType(animation.type, block)
	})

	signals.animationTypeChange.add(function (animation) {

		var block = blocks[animation.id]

		//block.dom.appendChild(createBackgroundImgElement(animation.assetUrl))

		if (animation.type === 'Character' || animation.type === 'Prop' || animation.type === 'Set Design') {
			block.dom.getElementsByClassName('backgroundImage')[0].style.backgroundImage = `url(${animation.assetUrl})`
			block.dom.getElementsByClassName('backgroundImage')[0].style.display = ''
			block.dom.getElementsByClassName('name')[0].style.display = 'none'
		}
		else {
			block.dom.getElementsByClassName('backgroundImage')[0].style.display = 'none'
			block.dom.getElementsByClassName('name')[0].style.display = ''
		}

		applyColorByType(animation.type, block)

		setPropertiesOnAnimation(animation)

		blocks[animation.id].update();

	});

	// function createBackgroundImgElement (imageUrl) {
	// 	var div = document.createElement('div')
	// 	div.style.backgroundImage = `url(${imageUrl})`
	// 	div.style.backgroundSize = 'contain'
	// 	div.style.backgroundRepeat = 'repeat-x'
	// 	div.style.height = "100%"
	// 	return div
	// }

	function getNearestTime(element, animation, direction) {
		let nearestTime = direction === "right" ? animation.end : animation.start

		let type = element.line ? "line" : "animation"

		let subComponentsOfSameType = animation.elements.filter(el => el[type])

		if (subComponentsOfSameType.length === 1) {
			return nearestTime
		} else {
			let timeDifference;
			let nearestNeighbor = Object.assign({}, animation);

			subComponentsOfSameType.forEach(el => {
				if (el === element) return;

				if (direction === "right") {
					timeDifference = el[type].startTime
				} else {
					timeDifference = el[type].endTime
				}


				if (direction === "right") {
					if (timeDifference <= nearestTime) {
						nearestNeighbor.start = el[type].startTime
					}
				} else {
					if (timeDifference >= nearestTime) {
						nearestNeighbor.end = el[type].endTime
					}
				}

			})


			return direction === "right" ? nearestNeighbor.start : nearestNeighbor.end
		}
	}

	function applyColorByType(type, block) {

		if (type === 'Character') {
			block.dom.style.backgroundColor = "rgb(238,255,121,0.5)"
		} else if (type === 'Prop') {
			block.dom.style.backgroundColor = "rgb(210,82,82,0.5)"
		} else if (type === 'Set Design') {
			block.dom.style.backgroundColor = "rgb(210,82,82,0.5)"
		} else if (type === 'Experience') {
			block.dom.style.backgroundColor = "rgb(45,123,255,0.5)"
		} else if (type === 'Sound') {
			block.dom.style.backgroundColor = "rgb(121,238,255,0.5)"
		} else if (type === 'Overlay') {
			block.dom.style.backgroundColor = "rgb(255,176,45,0.5)"
		} else if (type === 'Unassigned Node') {
			block.dom.style.backgroundColor = "rgb(121,171,255,0.5)"
		}


	}

	function setPropertiesOnAnimation(animation) {

		//TODO figure out what this does again.
		if (animation.type === 'CHARACTER') {
			animation.origin = {
				position: [0, 0, 0],
				rotation: [0, 0, 0]
			}
			animation.elements = []
		}
	}

	signals.animationAdded.add(function (animation) {

		var block = new Block(animation);
		container.dom.appendChild(block.dom);

		// block.dom.appendChild(createBackgroundImgElement(animation.assetUrl))
		if (animation.type === 'Character' || animation.type === 'Prop' || animation.type === 'Set Design') {
			if (animation.phase === 'needsAsset') {
				block.dom.getElementsByClassName('name')[0].style.display = ''
			} else {
				block.dom.getElementsByClassName('name')[0].style.display = 'none'
			}
			block.dom.getElementsByClassName('backgroundImage')[0].style.backgroundImage = `url(${animation.assetUrl})`
			block.dom.getElementsByClassName('backgroundImage')[0].style.display = ''
		}
		else {
			block.dom.getElementsByClassName('backgroundImage')[0].style.display = 'none'
			block.dom.getElementsByClassName('name')[0].style.display = ''
		}

		applyColorByType(animation.type, block)

		blocks[animation.id] = block;

	});

	signals.resetTimeline.add(function (animation) {
		blocks = {}
		subBlocks = {}
	});

	signals.animationModified.add(function (animation) {

		const block = blocks[animation.id];

		if (block) {
			block.update();
		}

	});

	signals.animationSelected.add(function (animation) {

		if (blocks[selected] !== undefined) {

			blocks[selected].deselect();

		}

		if (subBlocks[selectedSubBlock] !== undefined) {

			subBlocks[selectedSubBlock].deselect();

		}

		if (animation === null) return;

		selected = animation.id;
		blocks[selected].select();

	});

	signals.animationSubComponentSelected.add(function (el, animation) {

		if (blocks[selected] !== undefined) {

			blocks[selected].deselect();

		}

		if (subBlocks[selectedSubBlock] !== undefined) {

			subBlocks[selectedSubBlock].deselect();

		}

		if (animation === null) return;

		selectedSubBlock = el.id;
		subBlocks[selectedSubBlock].select();
	});

	signals.animationRemoved.add(function (animation) {

		var block = blocks[animation.id];
		container.dom.removeChild(block.dom);

		delete blocks[animation.id];

	});

	signals.timelineScaled.add(function (value) {

		scale = value;

		for (var key in blocks) {

			blocks[key].update();

		}

	});

	signals.animationRenamed.add(function (animation) {

		blocks[animation.id].update();

	});

	signals.effectRenamed.add(function (effect) {

		for (var key in blocks) {

			var block = blocks[key];

			if (block.getAnimation().effect === effect) {

				block.update();

			}

		}

	});

	return container;

};

export default Animations



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/Timeline.Animations.js
// module id = null
// module chunks = 